import * as React from 'react';
import { Card } from 'react-bootstrap';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import { getNextStep, getOverview } from '../../../../actions/claimHistoryActionsV2'
import ClaimsProgressBar from '../ClaimHistoryComponents/ClaimsProgressBar';
import '../ClaimHistoryComponents/ClaimHistoryComponents.css';
import { HashLink as Link } from 'react-router-hash-link';
import { CLAIM_HISTORY_V2 } from '../../../../routes/routes';
import ClaimsNextStep from '../ClaimHistoryComponents/ClaimsNextStep';

class ClaimRegistration extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.handleBackClick = this.handleBackClick.bind(this);
    }

    async handleClick() {
        this.props.handleGetNextStep();
    }

    async handleBackClick() {
        this.props.handleClaimsBackClick();
    }

    render() {
        const scrollWithOffset = (el) => {
            const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
            const yOffset = -90;
            window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
        }
        const stepsList = this.props.claimSubmit.claimProgress.claimSteps.filter(x => x.overallEstProgressBar !== null).length > 0
        let nrToUse = -1
        if (this.props.claimSubmit.claimProgress) {
            for (var i = 0; i < this.props.claimSubmit.claimProgress.claimSteps.length - 1; i++) {
                if (this.props.claimSubmit.claimProgress.claimSteps[i + 1].claimStepDescription.toLowerCase() !== this.props.claimSubmit.claimProgress.claimSteps[i].claimStepDescription.toLowerCase()) {
                    nrToUse += 1
                    if (this.props.claimSubmit.claimProgress.claimSteps[i].claimStepDescription.toLowerCase() === this.props.claimSubmit.selectedClaimProgressStep.claimStepDescription.toLowerCase()) {
                        break;
                    }
                }
            }
        }
        const claimStepDescription = this.props.claimSubmit.selectedClaimProgressStep.claimStepDescription.toLowerCase();
        const claimStep = this.props.claimSubmit.claimProgress.claimSteps.filter(x => x.claimStepDescription.toLowerCase() === claimStepDescription)[0];
        return (
            <>
                <button className="claims-back-button" onClick={this.handleBackClick}> <img className="claims-back-button-img" src="/my-policy/Images/Claims/ClaimsV2/Dropdown-arrow-left.png" alt="" title="" />Back</button>
                <div id="ClaimOverView">
                    {stepsList && !this.props.claimSubmit.selectedClaimProgressStep.isComplete && claimStepDescription && (claimStep.overallEstCompletionDate || claimStep.overallEstLatestDate) &&
                        <Card className="content-box-padding-20px-with-box-shadow mb-15px">
                            <div className="row noma">
                                <div className="col-12 nopa">
                                    <ClaimsProgressBar />
                                </div>
                            </div>
                        </Card>
                    }
                    <Card className="content-box-padding-20px-with-box-shadow">
                        <div className="row noma">
                            <div className="col-12 nopa">
                                <div className="row noma">
                                    <div className="claims-noc-step-header-icon-area">
                                        {
                                            (!this.props.claimSubmit.selectedClaimProgressStep.isComplete) &&
                                            <>
                                                <img src={"/my-policy/Images/Claims/Numbers/" + nrToUse + "-red.png"} alt={"Step " + nrToUse} title={"Step" + nrToUse} />
                                            </>
                                        }
                                        {
                                            (this.props.claimSubmit.selectedClaimProgressStep.isComplete) &&
                                            <>
                                                <img alt="Step 2: Completed" title="Step 2: Completed" src="/my-policy/Images/Claims/Numbers/step-success-32x32px.svg" />
                                            </>
                                        }
                                    </div>
                                    <div className="col nopa claims-noc-step-header-title-area">
                                        <h3>Claim registration</h3>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 nopa mt-10px">
                                <div className="font-weight-500 mb-0px">
                                    Schweet news alert.... Your claim has been registered under claim no. <span className='text-bold'>{this.props.claimSubmit.selectedClaim.claimNumber}.</span>
                                    {
                                        (!this.props.claimSubmit.selectedClaimProgressStep.isComplete) &&
                                        <>
                                            {!isMobile &&
                                                <>
                                                    <br /><br />
                                                    <span>Scroll down to the<Link className="text-red" to={CLAIM_HISTORY_V2 + "#claimFAQ"} scroll={el => scrollWithOffset(el)}> <b className="text-underline">FAQ’s</b></Link> for more info.</span>
                                                </>
                                            }
                                            {isMobile &&
                                                <>
                                                    <br /><br />
                                                    <span>Scroll down to the<Link className="text-red"> <b>FAQ’s</b></Link> for more info.</span>
                                                </>
                                            }
                                        </>
                                    }
                                </div>
                                <hr className="mt-18px mb-15px claims-v2-hr-2px" />
                            </div>
                            {this.props.claimSubmit.selectedClaimProgressStep.claimRegistrationStep.nameOfConsultant &&
                                <div className="col-12 nopa">
                                    <div className="row noma">
                                        <div className="col nopa">
                                            <p className="card-subheading text-left text-bold mb-0px noc-step-subtitle">Claims consultant</p>
                                        </div>
                                        <div className={!isMobile ? "col text-right nopa" : "col-12 text-left nopa"}>
                                            <p className="text-14 mb-0px">{this.props.claimSubmit.selectedClaimProgressStep.claimRegistrationStep.nameOfConsultant}</p>
                                        </div>
                                    </div>
                                    <hr className="mt-15px mb-15px claims-v2-hr-2px" />
                                </div>
                            }
                            {this.props.claimSubmit.selectedClaim.incident &&
                                <div className="col-12 nopa">
                                    <div className="row noma">
                                        <div className="col nopa">
                                            <p className="card-subheading text-left text-bold mb-0px noc-step-subtitle">Type of claim</p>
                                        </div>
                                        <div className={!isMobile ? "col nopa text-right" : "col-12 nopa text-left"}>
                                            <p className="text-14 mb-0px">{this.props.claimSubmit.selectedClaim.incident}</p>
                                        </div>
                                    </div>
                                    <hr className="mt-15px mb-15px claims-v2-hr-2px" />
                                </div>
                            }
                            {this.props.claimSubmit.selectedClaim.productIncidentType.incidentType.incidentEventType.description &&
                                <div className="col-12 nopa">
                                    <div className="row noma">
                                        <div className="col nopa">
                                            <p className="card-subheading text-left text-bold mb-0px noc-step-subtitle">Cause of damage</p>
                                        </div>
                                        <div className={!isMobile ? "col text-right nopa" : "col-12 text-left nopa"}>
                                            <p className="text-14 mb-0px">{this.props.claimSubmit.selectedClaim.productIncidentType.incidentType.incidentEventType.description}</p>
                                        </div>
                                    </div>
                                    <hr className="mt-15px mb-15px claims-v2-hr-2px" />
                                </div>
                            }
                            {(this.props.claimSubmit.selectedClaimProgressStep.claimRegistrationStep.basicExcess && this.props.claimSubmit.selectedClaimProgressStep.claimRegistrationStep.basicExcess !== 0) || (this.props.claimSubmit.selectedClaimProgressStep.claimRegistrationStep.additionalExcess && this.props.claimSubmit.selectedClaimProgressStep.claimRegistrationStep.additionalExcess !== 0) &&
                                <div className="col-12 nopa">
                                    {this.props.claimSubmit.selectedClaimProgressStep.claimRegistrationStep.basicExcess && this.props.claimSubmit.selectedClaimProgressStep.claimRegistrationStep.basicExcess !== 0 &&
                                        <>
                                            <p className="card-subheading text-left text-bold mb-10px">Excess breakdown</p>
                                            <div className="row noma">
                                                <div className="col nopa">
                                                    <p className="font-weight-500 mb-0px">Basic excess</p>
                                                </div>
                                                <div className="">
                                                    <p className="text-bold mb-0px">{this.props.profile.currencySymbol} {this.props.claimSubmit.selectedClaimProgressStep.claimRegistrationStep.basicExcess.toFixed(2)}</p>
                                                </div>
                                            </div>
                                        </>
                                    }
                                    {this.props.claimSubmit.selectedClaimProgressStep.claimRegistrationStep.additionalExcess && this.props.claimSubmit.selectedClaimProgressStep.claimRegistrationStep.additionalExcess !== 0 &&
                                        <div className="row noma mt-10px">
                                            <div className="col nopa">
                                                <p className="font-weight-500  mb-0px">Additional excess/es</p>
                                            </div>
                                            <div className="">
                                                <p className="text-bold">{this.props.profile.currencySymbol} {this.props.claimSubmit.selectedClaimProgressStep.claimRegistrationStep.additionalExcess.toFixed(2)}</p>
                                            </div>
                                        </div>
                                    }
                                    <hr className="mt-15px mb-15px claims-v2-hr-2px" />
                                </div>
                            }
                            {(this.props.claimSubmit.selectedClaimProgressStep.claimRegistrationStep.totalExcess !== 0) && 
                                <>
                                    <div className="col-12 nopa">
                                        <div className="row noma">
                                            <div className="col nopa">
                                                <p className="card-subheading text-left text-bold mb-0px">Your total excess payment will be</p>
                                            </div>
                                            <div>
                                                <p className={!isMobile ? "text-16 mb-0px text-red text-right" : "text-22 mb-0px mt-9px text-red text-right"}>{this.props.profile.currencySymbol} {this.props.claimSubmit.selectedClaimProgressStep.claimRegistrationStep.totalExcess.toFixed(2)}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={!isMobile ? "col-12 nopa mt-10px" : "col-12 nopa mt-15px"}>
                                        <div className="row noma">
                                            <div className="col nopa">
                                            <p className="text-14 mb-0px"> Psst... This is the amount you'll need to pay once your claim's been authorised. This amount might change once the damage assessment on your car/motorbike has been completed.</p>
                                            </div>
                                        </div>
                                        <hr className="mt-15px mb-15px claims-v2-hr-2px" />
                                    </div>
                                </>
                            }
                        </div>
                        <div className="col-12 nopa">
                            <div className="row noma">
                                <div className="col nopa">
                                    <p className="next-step-subheading mb-0">Next step</p>
                                </div>
                            </div>
                        </div>
                        <div className="row noma">
                            <div className="col-12 nopa">
                                <ClaimsNextStep />
                            </div>
                        </div>
                    </Card>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        firebase: state.firebase,
        profile: state.profile,
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        handleClaimsBackClick: () => dispatch(getOverview()),
        handleGetNextStep: () => dispatch(getNextStep()),

    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ClaimRegistration);
